import { ITableField } from 'shared/Table'
import { InspectorCheckResult } from '../../inspection.types'
import timeUtils from 'utils/time.utils'

/**
 * Форматирует дату создания
 */
const formatCreatedDate = (dateString: string): string => {
  const date = new Date(dateString)
  return timeUtils.formatDate(date, 'dd.MM.yyyy') || ''
}

const checkResultsTableFields: ITableField<InspectorCheckResult, keyof InspectorCheckResult>[] = [
  {
    key: 'team',
    getter: (item) => item.team?.name || '—',
    sortGetter: (item) => item.team?.name || '',
    header: 'Команда',
    width: '150px',
  },
  {
    key: 'project',
    getter: (item) => item.project?.name || '—',
    sortGetter: (item) => item.project?.name || '',
    header: 'Название проекта',
    width: '250px',
  },
  {
    key: 'inspector',
    getter: (item) => item.inspector?.info?.name || 'Не назначен',
    sortGetter: (item) => item.inspector?.info?.name || '',
    header: 'Эксперт',
    width: '150px',
  },
  {
    key: 'createdAt',
    getter: (item) => formatCreatedDate(item.createdAt),
    sortGetter: (item) => item.createdAt,
    header: 'Создано',
    width: '120px',
  },
  {
    key: 'grade',
    getter: (item) => (item.grade !== null ? item.grade.toString() : '—'),
    sortGetter: (item) => item.grade ?? -1,
    header: 'Оценка',
    width: '100px',
  },
]

export default checkResultsTableFields
